import axios from "axios";

export const getEmailTemplates = (clientId) => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/EmailTemplate/getTemplates/" + clientId)
    .then((res) => res.data);
};

export const getEmailTypes = () => {
  return axios
    .get(import.meta.env.VITE_BACKEND_API + "/api/EmailTemplate/getEmailTypes/")
    .then((res) => res.data);
};

export const addEmailTemplate = (newTemplate) => {
  return axios
    .post(import.meta.env.VITE_BACKEND_API + "/api/EmailTemplate/addTemplate/", newTemplate)
    .then((res) => res.data);
};

export const editEmailTemplate = (editedTemplate) => {
  return axios
    .put(import.meta.env.VITE_BACKEND_API + "/api/EmailTemplate/editTemplate/", editedTemplate)
    .then((res) => res.data);
};

export const deleteEmailTemplate = (templateId) => {
  return axios
    .delete(import.meta.env.VITE_BACKEND_API + "/api/EmailTemplate/deleteTemplate/" + templateId)
    .then((res) => res.data);
};
